import React from 'react';
import { Card, CardBody } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import { FileText, PenTool } from 'lucide-react';
import { ModeSelectionProps } from '../types';

const ModeSelection: React.FC<ModeSelectionProps> = ({ onModeSelect }) => {
  const { t } = useTranslation('admin');

  return (
    <div className="space-y-8 py-8">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          {t('guides.modal.createGuide.title')}
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">{t('guides.modal.createGuide.subtitle')}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card
          isPressable
          className="cursor-pointer hover:shadow-md transition-shadow"
          onPress={() => onModeSelect('pdf')}
        >
          <CardBody className="p-6 text-center">
            <div className="flex flex-col items-center space-y-3">
              <div className="p-3 bg-blue-100 dark:bg-blue-900 rounded-full">
                <FileText className="w-6 h-6 text-blue-600 dark:text-blue-400" />
              </div>
              <h4 className="font-semibold text-gray-900 dark:text-gray-100">
                {t('guides.modal.createGuide.options.pdf.title')}
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {t('guides.modal.createGuide.options.pdf.description')}
              </p>
            </div>
          </CardBody>
        </Card>

        <Card
          isPressable
          className="cursor-pointer hover:shadow-md transition-shadow"
          onPress={() => onModeSelect('manual')}
        >
          <CardBody className="p-6 text-center">
            <div className="flex flex-col items-center space-y-3">
              <div className="p-3 bg-green-100 dark:bg-green-900 rounded-full">
                <PenTool className="w-6 h-6 text-green-600 dark:text-green-400" />
              </div>
              <h4 className="font-semibold text-gray-900 dark:text-gray-100">
                {t('guides.modal.createGuide.options.manual.title')}
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {t('guides.modal.createGuide.options.manual.description')}
              </p>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ModeSelection;
